module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_029"
    }
  }, [_vm._v("It turned out there were hardly any, and a few of the aviators even had to admit they liked the XFF-1. It was fast. The big two-seater could outrun the pint-sized Boeing F4B fighter by a dozen miles per hour. It was the landing gear, of course. With the gear folded up into Myrtle’s bulbous underside, the plane was aerodynamically clean.")])]), _c('a', {
    attrs: {
      "id": "file_029"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The revolutionary folding gear was also one of the most annoying problems discovered during the tests. Navy planes are exposed to a lot of bumps and bounces as they thump down on the deck of an aircraft carrier, and as the test pilots simulated the abuse Myrtle would get while at sea, sometimes there were problems. The navy would call Grumman with the bad news: “We had a gear failure. "), _c('em', [_vm._v("Again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an issue of pride more than anything else. Both Grumman and the navy knew the gear could be fixed. And they were both aware that the XFF-1 was a winner. All of the problems brought to light were minor—teething troubles no worse than those seen on any other new airplane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The proof came at the end of 1932, when the navy ordered twenty-seven fighters. Grumman was ready, with yet another move to bigger facilities a month before. The empty factory building was farther east on Long Island, in Farmingdale, New York. The building had originally been built for making trucks, and there was plenty of room for a large assemblage of new Grumman aircraft.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_029"
    }
  }, [_vm._v("The twenty-seven planes were designated FF-1s, with the X for experimental dropped from the ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("designation. When the planes began flying with the fleet, the aviators called them “Fifis,” a more endearing version of the formal navy Bureau of Aeronautics’ FF-1 code.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The revolutionary traits of the new Grumman fighter took some getting used to for the “leather and goggle” generation of pilots who would be flying them. Familiar with the sights and sounds of an open-cockpit pursuit, pilots claimed that when they flew the FF-1 with its cockpit closed, it drove them crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Worse yet, they had never had to mess around with landing gear before. The gear was always simply “down” and fixed on anything they had ever flown. When a Fifi’s throttle was chopped with the wheels still up, a buzzer sounded in the cockpit. But even with this warning, many a preoccupied aviator came scraping in on his belly, supremely embarrassed by his inattention. No matter, mechanics soon found. The Grumman machines were tough. They lifted the plane, dropped the wheels, and hammered out the dents.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d822712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_029.vue
// module id = 138
// module chunks = 0